module.exports = __webpack_public_path__ + "img/water.e54d248b.svg";